exports.IDS = {
  // IMG_URL: "http://127.0.0.1:4342",
  IMG_URL: "https://lahanujinode.profcymadev.com:4346",

  // IMG_URL: "https://hindustansolarnode.profcymadev.com:1518",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",

  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  user_status: {
    Requested: 1,
    Approved: 2,
    Rejected: 3,
  },

  property_status: {
    Requested: 1,
    InProgress: 2,
    Approved: 3,
    Rejected: 4,
  },

  property_type: {
    Residential: 1,
    Commercial: 2,
    Plot: 3,
    Villa: 4,
  },

  users_type: {
    Admin: "Admin",
    Customer: "Customer",
    Broker: "Broker",
    Builder: "Builder",
  },

  user_role: {
    Admin: 1,
    Customer: 2,
    Broker: 3,
    Builder: 4,
  },
};
